import PropTypes from 'prop-types';
import React from 'react';

import { SeatedContext } from '../../../../../context/seatedContext';

import { fetcher } from '@weezevent/weezjs-core';
import Order from '../../../../../models/order';

import { Trans, withTranslation } from 'react-i18next';

import OrderSelector from './orderSelector';
import { Button, Icon, Header, List, Grid, Message, Modal } from 'semantic-ui-react';

import SwapSeatMap from './swap-seat-selector';

import '../../../../../styles/attendees/swap.css';

class ManualSeatlibSelection extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            currentAttendee: null,
            currentOrders: null,
            currentZone: this.findMostUsedZone(),
            attendeesMap: [],
            ordersNotFulfilled: [],
            selectedAttendees: this.props.selectedAttendees,
            error: null,
            zoneOver: null,
            selectedContingent: this.props.selectedAttendees[0].booking.contingent,
            selectedCategory: this.props.selectedAttendees[0].booking.category
        };
    }

    /**
     * Generates a random hex color
     */
    generateRandomColor() {
        return Math.floor(Math.random() * 0x10000000)
            .toString(16)
            .slice(-6);
    }

    /**
     * Launches selection etc
     */
    showMap() {
        let attendeesMap = this.state.selectedAttendees.reduce((map, attendee) => {
            map[attendee.pk] = {
                attendee: attendee.pk,
                newSeat: null,
                manual: false,
                color: this.generateRandomColor(),
                zone: attendee.booking.seat.zone_name
            };
            return map;
        }, {});

        this.currentCoords = {};

        this.setState({
            attendeesMap,
            currentOrders: null
        });
    }

    getMouseMoveListener() {
        return event => {
            let { clientX, clientY } = event;

            // Let's be honest
            // There is no need to trigger an update
            // by setting this on the state
            this.currentCoords = {
                clientX,
                clientY
            };
        };
    }

    componentDidUpdate(previousProps) {
        if (previousProps.selectedAttendees !== this.props.selectedAttendees || !this.state.selectedContingent) {
            this.setState({
                // no need to check all attendees, it was done previously on compatibility check
                selectedContingent: this.props.selectedAttendees[0].booking.contingent,
                selectedCategory: this.props.selectedAttendees[0].booking.category
            });
        }
    }

    componentDidMount() {
        window.addEventListener('mousemove', this.getMouseMoveListener());
        // TODO: fix orders
        this.showMap();
    }

    componentWillUnmount() {
        window.removeEventListener('mousemove', this.getMouseMoveListener());
    }

    getSelectedAttendeesInventory() {
        return this.props.selectedAttendees[0].booking.inventory;
    }

    /**
     * Fetches orders from API
     */
    getOrders() {
        let orders = `/ticket/organizations/${this.props.organization.id}/events/${this.props.event.id}/orders`;
        fetcher
            .get(orders, {
                query: {
                    id_transaction__in: this.state.selectedAttendees.map(attendee => attendee.order.id_transaction).join(',')
                }
            })
            .then(ordersApi => {
                let orders = ordersApi.response.map(order => new Order(order));

                let hasUnfulfilledOrders = Boolean(this.getUnfulfilledOrders(orders).length);

                if (!hasUnfulfilledOrders) {
                    this.showMap();
                }

                this.setState({
                    currentOrders: orders
                });
            })
            .catch(e => {
                // do something
                console.error(e);
                throw e;
            });
    }

    /**
     * Gets all orders that are partially selected (unfullfilled)
     */
    getUnfulfilledOrders(orders) {
        return orders.filter(order => {
            return !order.includesAllAttendees(this.state.selectedAttendees);
        });
    }

    /**
     * Utility method to check is there are unfulfilled orders
     */
    hasUnfulfilledOrders() {
        let unfulfilled = this.getUnfulfilledOrders(this.state.currentOrders);
        return Boolean(unfulfilled.length);
    }

    /**
     * Check zones of all selected participants
     * and return the most used one
     */
    findMostUsedZone() {
        // Count all zones
        let zones = this.props.selectedAttendees
            .reduce((zones, attendee) => {
                let attendeeZone = attendee.booking.zone;
                let exists = zones.find(zone => zone.id === attendeeZone);
                if (!exists) {
                    zones.push({
                        id: attendeeZone,
                        count: 1,
                        name: attendee.booking.seat_zone_name
                    });
                    return zones;
                }

                exists.count++;
                return zones;
            }, [])
            .sort((zone1, zone2) => zone1.count - zone2.count);

        // Get id of most used zone
        return zones[0];
    }

    /**
     * Maps the selected seats to the selected users
     */
    mapSeatsToUsers(selectedSeats) {
        // be smart while selecting seats
        let attendeesMap = Object.assign({}, this.state.attendeesMap);

        let selectedForSwap = null;
        let freeAttendees = Object.values(attendeesMap).filter(map => !map.newSeat);

        if (freeAttendees.length >= selectedSeats.length) {
            // apply to free attendees
            selectedForSwap = freeAttendees;
        } else {
            // Apply to all free attendees + non manual attendees
            selectedForSwap = Object.values(attendeesMap).filter(map => !map.newSeat || !map.manual);
        }

        // Apply new seats
        for (let i = 0; i < selectedSeats.length; i++) {
            if (!selectedForSwap[i]) {
                // forget remaining seats
                break;
            }
            selectedForSwap[i].newSeat = selectedSeats[i];
            selectedForSwap[i].zone = this.state.currentZone;
            attendeesMap[selectedForSwap[i].attendee] = selectedForSwap[i];
        }

        this.setState({
            attendeesMap,
            selectedSeats: selectedSeats.concat(this.state.selectedSeats)
        });
    }

    /**
     * Returns Seat objects from an { attendee, seat } map
     */
    getSelectedSeatsFromMap() {
        return Object.values(this.state.attendeesMap)
            .map(map => map.newSeat)
            .filter(seat => seat);
    }

    /**
     * Seatlib callback
     */
    onSeatsSelected(seats) {
        if (!seats.length) {
            return;
        }

        let selectedSeats = this.getSelectedSeatsFromMap();
        // Clear already selected seats
        seats = seats.filter(selectedSeat => selectedSeats.findIndex(seat => seat.uuid === selectedSeat.uuid) === -1);

        // Clear non compatible seats (contingent && category && not booked)
        seats = seats.filter(seat => {
            let contingent = seat.contingent === this.state.selectedContingent;
            let category = seat.category === this.state.selectedCategory;
            let booked = Boolean(seat.active_booking);

            return contingent && category && !booked;
        });

        // Map seat to only selected attendee
        if (seats.length === 1 && this.state.currentAttendee) {
            let attendeesMap = Object.assign({}, this.state.attendeesMap);
            attendeesMap[this.state.currentAttendee.pk].newSeat = seats[0];
            attendeesMap[this.state.currentAttendee.pk].zone = this.state.currentZone;
            attendeesMap[this.state.currentAttendee.pk].manual = true;

            return this.setState({
                currentAttendee: null,
                attendeesMap
            });
        }

        // All seats are already selected
        if (selectedSeats.length === this.state.selectedAttendees.length) {
            return;
        }

        return this.mapSeatsToUsers(seats);
    }

    /**
     * Display error
     */
    error(message) {
        this.setState(
            {
                error: message
            },
            () => {
                setTimeout(() => {
                    this.setState({
                        error: null
                    });
                }, 3000);
            }
        );
    }

    /**
     * Triggered when user clicks on "ok"
     */
    onSubmit() {
        const { t } = this.props;
        let selectedSeats = this.getSelectedSeatsFromMap();
        if (!selectedSeats.length) {
            return this.error(t('attendees.actions.errors.selectAtLeastOne'));
        }

        if (selectedSeats.length !== this.state.selectedAttendees.length) {
            this.error(
                t('attendees.actions.errors.selectXSeats', {
                    needed: this.state.selectedAttendees.length
                })
            );
        }

        return this.props.onSubmit(this.state.attendeesMap);
    }

    /**
     * Select a single attendee
     */
    selectAttendee(attendee) {
        let { currentAttendee } = this.state;
        if (currentAttendee && currentAttendee.pk === attendee.pk) {
            return this.setState({
                currentAttendee: null
            });
        }

        this.setState({
            currentAttendee: attendee
        });
    }

    /**
     * Renders error
     */
    renderError() {
        if (!this.state.error) {
            return null;
        }

        return <Message negative> {this.state.error} </Message>;
    }

    /**
     * Renders a row on attendee list
     */
    renderAttendeeRow(attendee) {
        const { t } = this.props;
        if (!this.state.attendeesMap[attendee.pk]) {
            // wtf
            return;
        }

        let { newSeat, zone, color } = this.state.attendeesMap[attendee.pk];

        // Made functions only to match previous coding style
        let oldSeat = {
            row: () => attendee.booking.row,
            seat: () => attendee.booking.seat,
            access: () => attendee.booking.access,
            zone: () => attendee.booking.zoneName
        };

        let isSelected = this.state.currentAttendee && this.state.currentAttendee.pk === attendee.pk;
        let className = 'attendee-swap-attendee-item' + (isSelected ? ' attendee-swap-selected-attendee' : '');

        // If there is no chosen zone, it means w are in current zone
        if (!zone) {
            zone = { name: oldSeat.zone() };
        }

        return (
            <List.Item onClick={() => this.selectAttendee(attendee)} className={`${className} item-padding`}>
                <Header as="h5">
                    <div className="attendee-swap-color-marker" style={{ backgroundColor: `#${color}` }}></div>
                    {attendee.name}
                </Header>
                <div>
                    <div>
                        {t('ticket.overview.dividerFrom')} • {`${oldSeat.zone()} - ${oldSeat.access()} R${oldSeat.row()} S${oldSeat.seat()}`}
                    </div>
                    <br />
                    <div>
                        {t('ticket.overview.dividerTo')} • {newSeat ? `${zone.name} - ${newSeat.access} R${newSeat.row} S${newSeat.seat}` : t('attendees.actions.noNewSeatYet')}
                    </div>
                </div>
            </List.Item>
        );
    }

    /**
     * Renders attendee sidebar
     */
    renderSelectedAttendeesSidebar() {
        return (
            <List basic className="swap-attendee-list">
                {this.state.selectedAttendees.map(attendee => {
                    return this.renderAttendeeRow(attendee);
                })}
            </List>
        );
    }

    /**
     * Renders the order picker for not fulfilled orders
     */
    renderOrdersNotFulfilled() {
        return (
            <OrderSelector
                orders={this.getUnfulfilledOrders(this.state.currentOrders)}
                selectedAttendees={this.state.selectedAttendees}
                onSelect={order => {
                    let { selectedAttendees } = this.state;
                    let orderAttendees = order.attendees.filter(attendee => selectedAttendees.findIndex(sattendee => sattendee.pk === attendee.pk) === -1);
                    let newAttendees = selectedAttendees.concat(orderAttendees);

                    // This promise enables us to "wait" until the state
                    // is set, so we can properly handle auto-submitting
                    this.setState(
                        {
                            selectedAttendees: newAttendees
                        },
                        () => {
                            if (!this.hasUnfulfilledOrders()) {
                                this.postOrderSelection();
                            }
                        }
                    );
                }}
                onSubmit={() => {
                    this.postOrderSelection();
                }}
            />
        );
    }

    postOrderSelection() {
        this.props.setSelectedAttendees(this.state.selectedAttendees);
        this.showMap();
    }

    render() {
        if (this.state.currentOrders && this.hasUnfulfilledOrders()) {
            return this.renderOrdersNotFulfilled();
        }

        let count = Object.values(this.state.attendeesMap).filter(({ newSeat }) => newSeat).length;
        let needed = this.state.selectedAttendees.length;

        let { currentZone } = this.state;

        return (
            <React.Fragment>
                <div>
                    <Modal.Content>
                        {this.renderError()}
                        <div className="attendees-manual-seatlib-header">
                            <div className="manual-selector-seats-qtty">
                                <Trans count={count} values={{ count, needed }} i18nKey="seats_over_selected">
                                    %count% / %needed% seats selected
                                </Trans>
                            </div>
                        </div>
                        <Grid columns={16}>
                            <Grid.Column width={12}>
                                <SwapSeatMap
                                    zone={{ uuid: currentZone.id || currentZone.uuid }}
                                    contingent={this.state.selectedContingent}
                                    category={this.state.selectedCategory}
                                    onSeatsSelected={this.onSeatsSelected.bind(this)}
                                    onZoneSelected={zone => this.setState({ currentZone: zone })}
                                    selectedAttendees={this.props.selectedAttendees}
                                    selectedSeats={this.state.attendeesMap}
                                />
                            </Grid.Column>
                            <Grid.Column width={4} className="attendees-sidebar-manual-swap">
                                {this.renderSelectedAttendeesSidebar()}
                            </Grid.Column>
                        </Grid>
                    </Modal.Content>

                    <Modal.Actions>
                        <Button basic color="red" inverted onClick={this.props.onCancel}>
                            <Icon name="remove" /> Return
                        </Button>
                        <Button color="green" disabled={count !== this.state.selectedAttendees.length} inverted onClick={() => this.onSubmit()}>
                            <Icon name="check" /> OK
                        </Button>
                    </Modal.Actions>
                </div>
            </React.Fragment>
        );
    }
}

ManualSeatlibSelection.propTypes = {
    event: PropTypes.object.isRequired,
    organization: PropTypes.object.isRequired,
    selectedAttendees: PropTypes.array.isRequired,
    setSelectedAttendees: PropTypes.func.isRequired,
    onCancel: PropTypes.func.isRequired,
    onSubmit: PropTypes.func.isRequired,
    currentInventory: PropTypes.object.isRequired,
    rates: PropTypes.array.isRequired,
    t: PropTypes.func.isRequired
};

// ProvidesseatedContext
function ManualSeatlibSelectionWrapper({ ...props }) {
    let {
        seatedContext: { inventory }
    } = React.useContext(SeatedContext);
    return <ManualSeatlibSelection {...props} currentInventory={inventory} />;
}

export default withTranslation()(ManualSeatlibSelectionWrapper);
